import React, { Fragment, useState, useCallback, useEffect } from 'react';

import {
    Button,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';

import ModalRequestCall from './ModalRequestCall';
import ModalSetupCall from './ModalSetupCall';
import ModalLogCall from './ModalLogCall';

export default function GroupTitle(props) {
    const {
        heading,
        icon,
        subheading,
        // organization,
        role,
        groupId,
        triggerLogCall,
        setTriggerLogCall,
        assignedGiver,
        allPlans,
        showLogs,
    } = props;

    const [modalRequestCall, setModalRequestCall] = useState(false);
    const toggleModalCallRequest = useCallback(() => {
        setModalRequestCall(!modalRequestCall);
    }, [modalRequestCall, setModalRequestCall]);

    const [modalSetupCall, setModalSetupCall] = useState(false);
    const toggleModalSetupCall = useCallback(() => {
        setModalSetupCall(!modalSetupCall);
    }, [modalSetupCall, setModalSetupCall]);

    const [modalScheduleCall, setModalScheduleCall] = useState(false);
    const toggleModalScheduleCall = useCallback(() => {
        setModalScheduleCall(!modalScheduleCall);
    }, [modalScheduleCall, setModalScheduleCall]);

    const [modallCallPlan, setModalCallPlan] = useState(false);
    const toggleModallCallPlan = useCallback(() => {
        setModalCallPlan(!modallCallPlan);
    }, [modallCallPlan, setModalCallPlan]);

    const [modalLogCall, setModalLogCall] = useState(false);
    const toggleModalLogCall = useCallback(() => {
        setModalLogCall(!modalLogCall);
    }, [modalLogCall, setModalLogCall]);

    const [modalCallLogs, setModalCallLogs] = useState(false);
    const toggleModalCallLogs = useCallback(() => {
        setModalCallLogs(!modalCallLogs);
    }, [setModalCallLogs, modalCallLogs]);

    useEffect(() => {
        if (triggerLogCall === true) {
            toggleModalLogCall();
            setTriggerLogCall(false);
        }
    }, [triggerLogCall, setTriggerLogCall, toggleModalLogCall]);

    return (
        <div className="app-page-title">
            <div className="page-title-wrapper">
                <div className="page-title-heading">
                    <div className="page-title-icon rounded-circle">
                        <i className={icon} />
                    </div>
                    <div>
                        {heading}
                        <div className="page-title-subheading">
                            {subheading}
                        </div>
                        {/*
                        <div className="page-title-subheading">
                            {organization}
                        </div>
                        */}
                    </div>
                </div>
                <div className="page-title-actions">
                    {role && role === 'giver' && (
                        <Fragment>
                            <Button
                                className="btn-pill mr-3"
                                color="info"
                                id="setup-call"
                                onClick={() => {
                                    toggleModalSetupCall();
                                }}
                            >
                                Setup Call
                            </Button>
                            <UncontrolledTooltip
                                placement="left"
                                target={'setup-call'}
                            >
                                Setup a Call to a Senior
                            </UncontrolledTooltip>

                            <Button
                                className="btn-pill mr-3"
                                color="success"
                                id="log-call"
                                onClick={() => {
                                    toggleModalLogCall();
                                }}
                            >
                                Call
                            </Button>
                            <UncontrolledTooltip
                                placement="bottom"
                                target={'log-call'}
                            >
                                Call a Senior
                            </UncontrolledTooltip>

                            {showLogs && showLogs === true && (
                                <Fragment>
                                    <Button
                                        className="btn-pill mr-3"
                                        color="secondary"
                                        id="calllogss"
                                        onClick={() => {
                                            toggleModalCallLogs();
                                        }}
                                    >
                                        Call Logs
                                    </Button>
                                    <UncontrolledTooltip
                                        placement="bottom"
                                        target={'calllogss'}
                                    >
                                        View My Call Logs
                                    </UncontrolledTooltip>

                                    <Modal
                                        isOpen={modalCallLogs}
                                        toggle={toggleModalCallLogs}
                                    >
                                        <ModalHeader
                                            toggle={toggleModalCallLogs}
                                        >
                                            Call Logs
                                        </ModalHeader>
                                        <ModalBody></ModalBody>
                                    </Modal>
                                </Fragment>
                            )}

                            <ModalSetupCall
                                modalSetupCall={modalSetupCall}
                                toggleModalSetupCall={toggleModalSetupCall}
                                modalScheduleCall={modalScheduleCall}
                                toggleModalScheduleCall={
                                    toggleModalScheduleCall
                                }
                                modallCallPlan={modallCallPlan}
                                toggleModallCallPlan={toggleModallCallPlan}
                                groupId={groupId}
                                allPlans={allPlans}
                            />

                            <ModalLogCall
                                modalLogCall={modalLogCall}
                                toggleModalLogCall={toggleModalLogCall}
                            />
                        </Fragment>
                    )}

                    {role && role === 'receiver' && assignedGiver.id && (
                        <Fragment>
                            <Button
                                className="btn-pill mr-3"
                                color="info"
                                id="request-gift"
                                onClick={() => {
                                    toggleModalCallRequest();
                                }}
                            >
                                Request a Call
                            </Button>
                            <UncontrolledTooltip
                                placement="left"
                                target={'request-gift'}
                            >
                                Request a Call to a Volunteer
                            </UncontrolledTooltip>

                            <ModalRequestCall
                                modalRequestCall={modalRequestCall}
                                toggleModalCallRequest={toggleModalCallRequest}
                                giver={assignedGiver}
                            />

                            {/* <ModalSetupCall
                                modalSetupCall={modalSetupCall}
                                toggleModalSetupCall={toggleModalSetupCall}
                                modalScheduleCall={modalScheduleCall}
                                toggleModalScheduleCall={toggleModalScheduleCall}
                                modallCallPlan={modallCallPlan}
                                toggleModallCallPlan={toggleModallCallPlan}
                                groupId={groupId}
                                /> */}
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    );
}
